import { useState } from "react";

/**
 * Renders a concept map from structured data:
 * { centro: string, rami: [{ titolo: string, figli: [string] }] }
 * Clean vertical tree: central black pill, hairline connectors, branch cards.
 */
export default function ConceptMap({ mappa }) {
  const [active, setActive] = useState(null);

  if (!mappa || !mappa.centro) {
    return (
      <p className="text-sm text-[color:var(--text-2)]" data-testid="concept-map-empty">
        Mappa concettuale non ancora disponibile per questa lezione.
      </p>
    );
  }

  const rami = mappa.rami || [];

  return (
    <div data-testid="concept-map">
      {/* Central node */}
      <div className="flex flex-col items-center">
        <div className="rounded-full bg-[color:var(--ink)] text-white font-extrabold tracking-tight px-6 py-3 text-center text-sm md:text-base shadow-md" data-testid="concept-map-center">
          {mappa.centro}
        </div>
        {rami.length > 0 && <div className="w-px h-6 bg-[color:var(--hairline)]" />}
      </div>

      {/* Branches */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {rami.map((ramo, i) => {
          const isActive = active === i;
          return (
            <button
              key={i}
              type="button"
              onClick={() => setActive(isActive ? null : i)}
              data-testid={`concept-map-branch-${i}`}
              aria-label={`Ramo: ${ramo.titolo}`}
              className={`text-left rounded-2xl border p-4 transition-colors duration-200 min-h-[44px] ${
                isActive
                  ? "border-[color:var(--ink)] bg-[color:var(--bg-subtle)]"
                  : "border-[color:var(--hairline)] bg-white hover:bg-[color:var(--bg-subtle)]"
              }`}
            >
              <div className="flex items-center gap-2">
                <span className={`inline-block w-2 h-2 rounded-full ${isActive ? "bg-[color:var(--volt)] ring-1 ring-black/10" : "bg-[color:var(--ink)]"}`} />
                <span className="font-bold text-sm tracking-tight">{ramo.titolo}</span>
              </div>
              <ul className="mt-2.5 space-y-1.5 pl-4">
                {(ramo.figli || []).map((figlio, j) => (
                  <li key={j} className="text-[13px] leading-5 text-[color:var(--text-2)] relative before:content-[''] before:absolute before:-left-3.5 before:top-[9px] before:w-2 before:h-px before:bg-[color:var(--hairline)]">
                    {figlio}
                  </li>
                ))}
              </ul>
            </button>
          );
        })}
      </div>
      <p className="mt-3 text-[11px] text-[color:var(--text-2)]">Tocca un ramo per evidenziarlo.</p>
    </div>
  );
}
